<div class="row d-flex align-items-center">

  <div class="col-sm-12 text-start" style="font-weight:bold" *ngIf="isWorkflowMandatory">
    A informação solicitada é fundamental para o tratamento do pedido e deverá ser confirmada com o subscritor.
    <br /><!--<br />-->
  </div>
  <div class="col-sm-12 text-start" style="font-weight:bold">
    Caso não sejam anexados os elementos clínicos, o pedido de aposentação será arquivado e terá de iniciar novo pedido.
    <br />
    <br />
  </div>

  <div class="col-sm-6">
    <h2 class="text-primary mb-0">
      {{cardConfiguration.title}}
    </h2>
  </div>


  <div class="col-sm-6 text-end">
    <button (click)="onExpandNewEntry()" type="button" [ngClass]="!expandNewEntry ? '' : 'disabled'" aria-label="Nova entrada" class="btn btn-link disable-on-fieldset"><span class="icon-add"></span> <span>{{'ClinicalSituation.IncapacityTable.AddItem' | translate}}</span></button>
  </div>

</div>


<!--New table entry inputs-->
<div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
  <button type="button" class="close" aria-label="Fechar" (click)="onCloseNewEntry()">
    <span aria-hidden="true" class="icon-close text-primary"></span>
  </button>
  <h3 class="text-primary">{{'ClinicalSituation.IncapacityTable.AddItem' | translate}}</h3>
  <incapacity-table-edit [itemList]="cardData.incapacityList" (listChanged)="onIncapacityListChanged($event)" [preFilledItem]="preFilledItem"></incapacity-table-edit>
</div>

<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">{{'ClinicalSituation.IncapacityTable.Cause' | translate}}</th>
      <th scope="col">{{'ClinicalSituation.IncapacityTable.DiagnoseDate' | translate}}</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let tableItem of cardData.incapacityList; let i = index">
      <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
        <td>{{tableItem.cause}}</td>
        <td class="fitwidth">{{tableItem.diagnoseDate | date : 'yyyy-MM-dd'}}</td>
        <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
          <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
            <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' :  disableTableRemoveIcons ? 'text-primary icon-more' : 'text-primary icon-edit'"></span>
          </button>
          <button *ngIf="!disableTableRemoveIcons" type="button" class="btn-icon" aria-label="Apagar" (click)="removeIncapacity(i,$event)">
            <span class="icon-trash p-1" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
          </button>
        </td>
      </tr>
      <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
        <td class="p-0" colspan="7" id="collapseBasic">
          <div class="ml-5 mr-5 p-4">
            <incapacity-table-edit [itemList]="cardData.incapacityList" [editIndex]="i" (listChanged)="onIncapacityListChanged($event)"></incapacity-table-edit>
          </div>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

<ng-container *ngIf="isWorkflowMandatory">
  <br />
  <div class="form-group">
    <div class="row">
      <div class="col-sm-12">
        <label for="ClinicalSubscDoc">
          <span class="mandatory">*</span>{{'ClinicalSituation.ClinicalSubscDoc' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.ClinicalSituation.ClinicalSubscDoc' | translate}}"></span>
        </label>
      </div>
      <div class="col-sm-4">
        <div class="btn-group btn-group-toggle">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.clinicalSubscDoc" [radioLabel]="clinicalSubscDoc">
            <input type="radio" (change)="sendDocChanged($event);" [(ngModel)]="cardData.clinicalSubscDoc" name="clinicalSubscDoc" #clinicalSubscDoc="ngModel" [value]="domain.value" required>
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <div class="form-group">
    <div class="row">
      <div class="col-sm-12">
        <label for="Observation">{{'ClinicalSituation.DocumentObservation' | translate}}</label>
        <textarea class="form-control" id="clinicalSubscDocObs" placeholder="{{'ClinicalSituation.ObsText' | translate}}" [(ngModel)]="cardData.clinicalSubscDocObs"
                  #clinicalSubscDocObs="ngModel"
                  name="clinicalSubscDocObs" rows="3" cols="100" maxlength="200"
                  [required]="cardData.clinicalSubscDoc?.toString()=='false'"
                  [disabled]="!cardData.clinicalSubscDoc || cardData.clinicalSubscDoc?.toString() != 'false'"
                  (ngModelChange)="excludeLineBreak2($event)" (keypress)="excludeLineBreak($event)">
    </textarea>
        <validation-message [control]="clinicalSubscDocObs"></validation-message>
      </div>
    </div>

  </div>
</ng-container>
